export default __webpack_public_path__ + "images/maria-usuario.jpg";